/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-08 10:50:48
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


function hasOnlyOneHash(str) {
  // 使用正则表达式查找字符串中#的出现次数
  const hashes = str.match(/#/g);
  
  // 如果有#号，但找到了多于一个#，返回false
  if (hashes.length !== 1) {
    return false;
  }
  
  // 如果找到一个#，返回true
  return true;
}


function getValidGradient(userGradient) {
  // 默认的渐变色数组
  const defaultGradient = [{
      offset: 0, color: '#ff0101' // 红色
  }, {
      offset: 1, color: '#ec8b92' // 色
  }];

  // 如果用户没有提供渐变色或者提供的不是数组，返回默认渐变色
  if (!Array.isArray(userGradient) || userGradient.length === 0) {
      return defaultGradient;
  }

  // 验证用户提供的渐变色数组
  const validGradient = userGradient.map(stop => {
    const { offset, color } = stop;
    // 检查 offset 是否为有效数字且在 0 到 1 的范围内
    const isValidOffset = typeof offset === 'number' && offset >= 0 && offset <= 1;

    // 检查 color 是否为有效的 CSS 颜色字符串
    // const isValidColor =  typeof color === 'string' && /(#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3}|rgb$\s*\d+\s*,\s*\d+\s*,\s*\d+\s*$|rgba$\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*?\.\d*\s*$)$/.test(color);
    const isValidColor =  typeof color === 'string' && /(#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3})$/.test(color);

    // 如果 offset 或 color 无效，返回 null，表示这个渐变点无效
    if (!isValidOffset || !isValidColor || !hasOnlyOneHash(color)) {
        return null;
    }

    // 如果渐变点有效，返回它
    return { offset, color };

  }).filter(stop => stop !== null); // 过滤掉无效的渐变点

  // 如果所有渐变点都无效，或者过滤后数组为空，返回默认渐变色
  if (validGradient.length === 0) {
      return [];
  }

  // 如果至少有一个有效的渐变点，返回验证后的渐变色数组
  return validGradient;
}

export default ({ title, list = [], color = [] }) => {
  // 使用示例
  var userProvidedGradient = [
    {offset: 0, color: color[0] }, 
    {offset: 1, color: color[1] }
  ];
  const validGradient = getValidGradient(userProvidedGradient);
  console.log('最终的',validGradient);
  return {
    title: {
      text: '安踏 数字品牌资产历史累积走势与关键影响因素'
    },
    tooltip: {},
    xAxis: {
      type: 'category',
      data: title,
      axisLabel: {
        rotate: 90,
        ...xAxisLabelColor,
      }
      
    },
    grid: {
      left: 100,
      right: 30,
      bottom: 90,
    },
    yAxis: {
      type: 'value',
      splitLine: { show: false },
      axisLabel: { ...yAxisLabelColor },
    },
    series: [
      {
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: validGradient,
            global: false // 缺省为 false
          }
        },
        data: list,
        type: 'bar'
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P4/chart.js